import React from 'react';
import { Button, Label, Switch } from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import FormGrid from './FormGrid';

export default function HazmatRateConditionField({
  condition,
  onChange,
  onRemove,
}) {
  const { criteria: value } = condition;

  function handleRemove() {
    onRemove(condition);
  }

  function handleChange(criteria) {
    onChange({ ...condition, criteria });
  }

  return (
    <FormGrid>
      <Label className="w-48">Hazmat</Label>
      <div className="flex items-center space-x-2">
        <Switch
          id="hazmat-toggle"
          value={value}
          checked={value}
          onCheckedChange={handleChange}
        />
        <Label htmlFor="hazmat-toggle">Hazmat</Label>
      </div>
      <div>
        <Button variant="icon" onClick={handleRemove}>
          <Trash className="w-3.5 h-3.5" />
        </Button>
      </div>
    </FormGrid>
  );
}
